import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import BackButton from '../widgets/back_button';
import config from '../../config';
import { IoIosCheckmark, IoIosClose } from 'react-icons/io';

function ManageDocumentsPayroll() {
    const [empresa, setEmpresa] = useState('');
    const [prefijo, setPrefijo] = useState('');
    const [numero, setNumero] = useState('');
    const [structure, setStructure] = useState('');
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [docLoading, setDocLoading] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);
    const [confirmRepro, setConfirmReprocesar] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const queryParams = new URLSearchParams({ empresa, prefijo, numero }).toString();
        const url = `${config.servBackEnd}/payroll/admin_document?${queryParams}`;

        fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(response => response.json())
            .then(data => setDocuments(data.ok ? data.data : []))
            .catch(error => console.error("Error fetching data:", error))
            .finally(() => setLoading(false));
    };

    const borrar = (id) => {
        setConfirmDelete(id);
    };

    const reprocesar = (id) => {
        setConfirmReprocesar(id);
    };

    const confirmBorrar = (id) => {
        const url = `${config.servBackEnd}/payroll/admin_document/delete_dian/${id}`;
        console.log(url)
        setDocLoading(true);
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(response => response.json())
            .then(data => setStructure(data.message))
            .catch(error => console.error("Error fetching data:", error))
            .finally(() => setDocLoading(false));
        setConfirmDelete(null);
    };

    const confirmReprocesar = (id) => {
        const url = `${config.servBackEnd}/payroll/admin_document/reprocess_dian/${id}`;
        console.log(url)
        setDocLoading(true);
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(response => response.json())
            .then(data => setStructure(data.message))
            .catch(error => console.error("Error fetching data:", error))
            .finally(() => setDocLoading(false));
        setConfirmReprocesar(null);
    }

    const cancelBorrar = () => {
        setConfirmDelete(null);
    };

    const cancelReprocesar = () => {
        setConfirmReprocesar(null);
    };

    const get_structure = async (url) => {
        setDocLoading(true);
        fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(response => response.json())
            .then(data => setStructure(data.message))
            .catch(error => console.error("Error fetching data:", error))
            .finally(() => setDocLoading(false));
    };

    // const json = (id) => get_structure(`${config.servBackEnd}/payroll/admin_document/structure/json/${id}`);
    const xml = (id) => get_structure(`${config.servBackEnd}/payroll/admin_document/structure/xml/${id}`);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(structure).then(() => {
            alert("Text copied to clipboard!");
        }).catch(err => console.error("Error copying text:", err));
    };

    return (
        <Container>
            <BackButton />
            <Row className="justify-content-md-center">
                <Col md={8}>
                    <h2 className="mt-4 mb-4">Manage Documents Payroll</h2>
                    <Form onSubmit={handleSubmit} className="d-flex align-items-center">
                        <Form.Group as={Row} className="m-3" controlId="formEmpresa">
                            <Form.Label column sm={3}>Empresa</Form.Label>
                            <Col sm={9}><Form.Control type="text" value={empresa} onChange={(e) => setEmpresa(e.target.value)} required /></Col>
                        </Form.Group>
                        <Form.Group as={Row} className="m-3" controlId="formPrefijo">
                            <Form.Label column sm={3}>Prefijo</Form.Label>
                            <Col sm={9}><Form.Control type="text" value={prefijo} onChange={(e) => setPrefijo(e.target.value)} required /></Col>
                        </Form.Group>
                        <Form.Group as={Row} className="m-3" controlId="formNumero">
                            <Form.Label column sm={3}>Numero</Form.Label>
                            <Col sm={9}><Form.Control type="number" value={numero} onChange={(e) => setNumero(e.target.value)} required /></Col>
                        </Form.Group>
                        <Button variant="primary" type="submit">Submit</Button>
                    </Form>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    <h3>Document List</h3>
                    {loading && <Spinner animation="border" role="status" className="d-flex justify-content-center my-3" />}
                    {!loading && documents.length > 0 && (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>ID Factura</th>
                                    <th>ID Empresa</th>
                                    <th>Tipo Documento</th>
                                    <th>Prefijo DIAN</th>
                                    <th>Número Factura</th>
                                    <th>Documento Cliente</th>
                                    <th>Total Venta</th>
                                    <th>Periodo</th>
                                    <th colSpan={2}>Accion</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documents.map((doc, index) => (
                                    <tr key={index}>
                                        <td>{doc.ID_CABECERA_NOMINA}</td>
                                        <td>{doc.ID_EMPRESA}</td>
                                        <td>{doc.TIPO_DOCUMENTO_NOMINA}</td>
                                        <td>{doc.TIPO_DOCUMENTO_NOMINA}</td>
                                        <td>{doc.NUMERO_DOCUMENTO_NOMINA}</td>
                                        <td>{doc.ID_EMPLEADO}</td>
                                        <td>{doc.COMPROBANTE_TOTAL}</td>
                                        <td>{doc.TELEFONO_EMPRESA}</td>
                                        <td><Button className='mr-1' onClick={() => xml(doc.ID_CABECERA_NOMINA)} variant='primary'>XML</Button></td>
                                        <td>
                                            {confirmDelete === doc.ID_CABECERA_NOMINA ? (
                                                <div>
                                                    <Button className='mr-1' onClick={() => confirmBorrar(doc.ID_CABECERA_NOMINA)} variant='success'><IoIosCheckmark /></Button>
                                                    <Button className='mr-1' onClick={cancelBorrar} variant='outline-danger'><IoIosClose /></Button>
                                                </div>
                                            ) : (
                                                <Button className='mr-1' onClick={() => borrar(doc.ID_CABECERA_NOMINA)} variant='danger'>Borrar</Button>
                                            )}
                                        </td>
                                        <td>
                                            {confirmRepro === doc.ID_CABECERA_NOMINA ? (
                                                <div>
                                                    <Button className='mr-1' onClick={() => confirmReprocesar(doc.ID_CABECERA_NOMINA)} variant='success'><IoIosCheckmark /></Button>
                                                    <Button className='mr-1' onClick={cancelReprocesar} variant='outline-danger'><IoIosClose /></Button>
                                                </div>
                                            ) : (
                                                <Button className='mr-1' onClick={() => reprocesar(doc.ID_CABECERA_NOMINA)} variant='danger'>Reprocesar</Button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                    {!loading && documents.length === 0 && <p className="text-center text-muted mt-3">No documents found.</p>}
                </Col>
            </Row>
            {docLoading && <Spinner animation="border" role="status" className="d-flex justify-content-center my-3" />}
            {!docLoading && structure && (
                <Row className="mt-4">
                    <Col>
                        <h3>Document Structure</h3>
                        <pre className="p-3 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }}>{structure}</pre>
                        <Button variant="secondary" onClick={copyToClipboard}>Copy Text</Button>
                    </Col>
                </Row>
            )}
        </Container>
    );
}

export default ManageDocumentsPayroll;



// WEBPACK FOOTER //
// ./src/components/configuracion/manageDocumentsPayroll.jsx